import React, { useEffect, useState } from 'react';
import { DropdownItemProps } from '@components/dropdown-blog';
import { tagsEndpoint } from '@constants/api';
import { useLocation } from '@reach/router';
import getBlogType from '@helpers/get-blog-type';
import DropdownCombobox from '../autocomplete/autocomplete';
import {
  Title,
  StyledWrapper,
  Container,
  CategoryList,
  CategoryTitleItem,
  InputWrapper,
  TitleStatic,
} from './categories-bar.styled';

interface CategoriesBlockProps {
  className?: string;
  postsType: string;
}

const postCollections = [
  { type: 'blog_post', label: 'Blog Posts' },
  { type: 'guides_post', label: 'Guides' },
  { type: 'case_studies_post', label: 'Case Studies' },
];

const CategoriesBlock = ({ className = '', postsType }: CategoriesBlockProps): JSX.Element => {
  const [tags, setTags] = useState<string[]>([]);
  const currentUrl = useLocation().pathname;
  const isActiveUrl = postCollections.some(
    (collection) =>
      currentUrl === getBlogType(collection.type) ||
      currentUrl === `${getBlogType(collection.type)}/`
  );

  useEffect(() => {
    Promise.resolve(fetch(tagsEndpoint))
      .then((response) => response.json())
      .then((data: string[]) => {
        const responseTags = data.length > 0 ? data : [];
        const sortedTags = responseTags.sort();
        setTags(sortedTags);
      })
      .catch(() => 'fetch error');
  }, []);

  const categoryItems: DropdownItemProps[] = tags.map((tag) => ({
    label: tag,
    link: `${getBlogType(postsType)}?category=${tag}`,
  }));

  categoryItems.push({
    label: 'Browse All',
    link: getBlogType(postsType),
  });

  return (
    <StyledWrapper>
      <Container className={className}>
        <CategoryList>
          <CategoryTitleItem>
            {postCollections.map((collection) =>
              collection.type === postsType && isActiveUrl ? (
                <TitleStatic key={collection.type}>{collection.label}</TitleStatic>
              ) : (
                <Title key={collection.type} href={getBlogType(collection.type)} color="white">
                  {collection.label}
                </Title>
              )
            )}
          </CategoryTitleItem>
        </CategoryList>
        <InputWrapper>
          <DropdownCombobox postsType={postsType} />
        </InputWrapper>
      </Container>
    </StyledWrapper>
  );
};

export default CategoriesBlock;
